import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';
import { ProductInvGridConfigModel } from 'app/data/models/master/op/product-inv-grid-config.model';

@Injectable()
export class OnlineProductInventoryGridConfigService {
    constructor(private http: AuthHttp) { }
    
    save(model: ProductInvGridConfigModel) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineProductInventoryGridConfig/Save", model)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/op/online-product-inventory-grid-config.service.ts